

<template>
      <div class="container-fluid bgColorBlack" data-aos="fade-up">
      <div class="container pt-5 pb-5">
        <div class="columns">  
        <div class="column is-6">
                <b-carousel class="is-block mx-auto" :indicator="false" :pause-info="false">
                    <b-carousel-item >
                        <section :class="`hero is-small commentsPaddingResponsive`">
                            <div class="hero-body">
                                <div class="positionTestimonials">
                                    <i class="far fa-comments is-size-1 iconResponsivePosition"></i>
                                    <h3 class="has-text-white is-size-1 textTestimonyResponsive">
                                        Testimonios
                                    </h3>
                                    <div class="separatorLine bgColorSecondary width40 mt-2 linePosition is-hidden-tablet"></div>
                                    <div class="separatorLine bgColorSecondary width40 mt-5 linePosition is-hidden-mobile"></div>
                                    <br class="is-hidden-mobile"><br class="is-hidden-mobile">
                                    <h3 class="has-text-white is-size-3 textTestimonyResponsive is-hidden-mobile">
                                        De clientes que confían en nuestro servicio
                                    </h3>
                                </div>
                            </div>
                        </section>
                    </b-carousel-item>
                </b-carousel>
          </div>
          <div class="column is-6">
                <b-carousel class="is-block mx-auto" :indicator="false" :pause-info="false">
                    <b-carousel-item v-for="(carousel, i) in carouselsOpinions" :key="i">
                        <section :class="`hero is-small commentsPaddingResponsive2`">
                            <div class="hero-body has-text-centered">
                                <img :src="carousel.img"> 
                                <h1 class="title has-text-white mb-2">{{carousel.name}}</h1>
                                <div class="mb-2">
                                    <font-awesome-icon icon="star" class="iconMenu colorPrimary ml-2" /> 
                                    <font-awesome-icon icon="star" class="iconMenu colorPrimary ml-2" /> 
                                    <font-awesome-icon icon="star" class="iconMenu colorPrimary ml-2" /> 
                                    <font-awesome-icon icon="star" class="iconMenu colorPrimary ml-2" /> 
                                    <font-awesome-icon icon="star" class="iconMenu colorPrimary ml-2" /> 
                                </div>
                                <h1 class="has-text-white is-size-5 fontWeightLight fontItalic">"{{carousel.text}}"</h1>
                            </div>
                        </section>
                    </b-carousel-item>
                </b-carousel>
          </div>            
        </div> 
      </div>         
    </div> 
</template>
<script>
export default {
    data () {
        return {
            carouselsOpinions: [
                { img: 'https://lfsoluciones.com.ar/onlineImgs/1.png', name: 'María Justina del Carmen', text: 'Llamé a la noche porque se rompió un caño del baño. Me generaron mucha confianza y lo arreglaron muy bien. Muy buena atención.', color: 'primary' },
                { img: 'https://lfsoluciones.com.ar/onlineImgs/2.png', name: 'Pablo Jose Brum', text: 'Llegué a casa a la mañana y sentí olor a gas, busqué en Google y los encontré, vinieron, encontraron la fuga y la arreglaron, todo de diez.', color: 'info' },
                { img: 'https://lfsoluciones.com.ar/onlineImgs/3.png', name: 'Marta Fernandez', text: 'Hace 10 años que los llamo siempre que necesito hacer alguna renovación o se me rompe algo, son los mejores de la ciudad.', color: 'info' },
                { img: 'https://lfsoluciones.com.ar/onlineImgs/4.png', name: 'Sabrina Jaquelina Papes', text: 'Vinieron al departamento a arreglar un problema con el horno porque los envío la inmobiliaria, quedó todo muy bien.', color: 'info' }
            ],
        }
    }
}
</script>
